import YRow from './src/main'

YRow.install = function(Vue) {
  Vue.component(YRow.name, YRow)
}

export default YRow
